import { ReactNode } from "react";
import cn from "classnames";

import { Panel as CommonPanel, PanelProps as CommonPanelProps } from "capitalrx-components-2.0/lib/general";

import styles from "./styles.module.scss";

export interface PanelContainerProps extends CommonPanelProps {
  children: ReactNode;
  noPadding?: boolean;
}

export const PanelContainer = (props: PanelContainerProps) => {
  const { children, className, noPadding } = props;
  const panelContainerClass = cn(className, styles["PanelContainer"], { NoPadding: noPadding });

  return (
    <CommonPanel {...props} className={panelContainerClass}>
      {children}
    </CommonPanel>
  );
};
